import { onlyCourse } from '../static/data';

/** Espejo de server/src/constants/taskAccess.js */
export const TASK_OBSERVER_TYPE_USERS = ['director', 'desarrollador'];

export const isTaskObserver = (user) => (
    TASK_OBSERVER_TYPE_USERS.includes(user?.typeUser)
);

/**
 * Alcance de visibilidad del calendario de /cursos.
 * Espeja `server/src/services/calendarScopeService.js`, que es quien decide de
 * verdad: aquí solo se usa para no dibujar controles que el backend rechazaría.
 */
export const CALENDAR_SCOPES = {
    STUDENT: 'student',
    TEACHER: 'teacher',
    ALL: 'all',
};

/** Permiso de ruta: reutiliza el listado `onlyCourse` del menú existente. */
export const hasCourseRouteAccess = (user) => onlyCourse.includes(user?.typeUser);

export const resolveCalendarScope = (user) => {
    if (user?.typeUser === 'estudiante') return CALENDAR_SCOPES.STUDENT;
    if (user?.typeUser === 'profesor') return CALENDAR_SCOPES.TEACHER;
    return CALENDAR_SCOPES.ALL;
};

export const canViewTasks = (scope, user = null) => (
    scope === CALENDAR_SCOPES.STUDENT
    || scope === CALENDAR_SCOPES.TEACHER
    || isTaskObserver(user)
);
